angular.module('routes.endpoints.EndpointsPayloadResolver', [
  'stack'
])

/**
 * The EndpointsPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class EndpointsPayloadResolver
 * @constructor
 * @module routes.endpoints.EndpointsPayloadResolver
 */
.factory('EndpointsPayloadResolver', [
  'GLOBAL',
  'ModelsService',
  function (GLOBAL, ModelsService) {
    'use strict';

    return function (params) {
      if (params.endpoint) {
        return ModelsService.initialize(params.endpoint, GLOBAL.apiPath + '/' + params.endpoint);
      }
      return {};
    };
  }
]);
